import React from 'react';
import { Box, getVariant } from '@apia/theme';
import { TResponsiveTableRowState } from '../types';

const NoMemoRowStatesRenderer = ({
  state,
}: {
  state: TResponsiveTableRowState;
}) => {
  const { Icon } = state;

  return (
    <Box
      sx={React.useMemo(
        () => ({
          '&, svg, path': {
            color: state.color ?? '',
          },
        }),
        [state.color],
      )}
    >
      <Icon
        {...getVariant('inherit')}
        title={state.tooltip}
        className={`${state.className ?? 'state'}_icon state_icon`}
      />
    </Box>
  );
};

export const RowStatesRenderer = React.memo(NoMemoRowStatesRenderer);
